const closingPeriod = `mutation{closingPeriod}`;

export default closingPeriod;
